import React from "react";
import cx from "classnames";
import moment from "moment";
import PropTypes from "prop-types";
import Datepicker from "rialto-icons/Datepicker";

import Button from "components/Button";
import { isMobileDevice, Translate } from "utils";

import styles from "./DateTime.css";

const { t } = new Translate("DateTime");

const DateTimeButton = (props) => {
  const { date, isTimeHidden, label, onChange, onChangeDateTime, onClick, time } = props;

  return isMobileDevice() ? (
    <div
      className={cx(styles.mobileInputButton, {
        [styles.active]: date || time,
      })}
    >
      <input
        defaultValue={
          isTimeHidden
            ? date && moment(date).format("YYYY-MM-DD")
            : date && `${moment(date).format("YYYY-MM-DD")}T${time}`
        }
        onChange={(e) =>
          isTimeHidden ? onChange("date", e.target.value) : onChangeDateTime(e.target.value)
        }
        type={isTimeHidden ? "date" : "datetime-local"}
      />
      <Datepicker />
    </div>
  ) : (
    <Button
      icon={<Datepicker />}
      label={date ? moment(date).format("L") : label}
      onClick={onClick}
    />
  );
};

DateTimeButton.propTypes = {
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  time: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onChangeDateTime: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  isTimeHidden: PropTypes.bool,
};

DateTimeButton.defaultProps = {
  label: t("select_date"),
};

export default DateTimeButton;
